import assign from 'lodash/assign';

import { AuthServiceModule } from 'services/auth/auth.service';
import { VolusionPaymentsSignupManagement } from
    'components/volusionPaymentsSignupManagement/volusionPaymentsSignupManagement.component';

import template from './conciergeIndicator.html';
import './conciergeIndicator.scss';

export const ConciergeIndicatorModule = angular
    .module('app.components.conciergeIndicator', [
        AuthServiceModule,
        VolusionPaymentsSignupManagement
    ]).component('conciergeIndicator', {
        template,
        bindings: {
            storeInformation: '<'
        },
        controller: class ConciergeIndicatorController {
            constructor(authService, $mdDialog) {
                'ngInject';

                assign(this, {
                    authService,
                    $mdDialog
                });
            }

            $onInit() {
                this.authService.isImpersonator().then((isImpersonator) => {
                    this.conciergeUser = isImpersonator;
                });
            }

            shouldShowAuthNetManagementLink() {
                const info = this.storeInformation;
                return !!info && info.authorizeNet
                    && info.authorizeNet.isPaymentsSignupSubmitted && !info.authorizeNet.accessToken;
            }

            manageAuthNet() {
                this.$mdDialog.show({
                    template: `
                    <md-dialog class="configure-authorize-net-edit-modal" aria-label="Edit Volusion Payments">
                        <md-dialog-content>
                            <volusion-payments-signup-management></volusion-payments-signup-management>
                        </md-dialog-content>
                    </md-dialog>
                    `,
                    clickOutsideToClose: true,
                    controller: this.basicDialogController({})
                });
            }

            basicDialogController(scopeVars) {
                return function DialogController($scope, $mdDialog) { // eslint-disable-line no-shadow
                    'ngInject'; // eslint-disable-line lines-around-directive

                    assign($scope, scopeVars);

                    $scope.closeDialog = function() {
                        $mdDialog.hide();
                    };
                };
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/conciergeIndicator/conciergeIndicator.component.js